import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { formStatusToggle } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function updateFormStatus({
  accountId,
  formId,
  surveyStatus,
}: Targuments): Promise<TResult> {
  const response = await fetch(
    formStatusToggle(accountId, formId, surveyStatus),
    {
      method: 'PUT',
      headers: {
        Authorization: getTokenWithType(),
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  formId: number;
  surveyStatus: string;
};

type Targuments = {
  accountId: number;
  formId: number;
  surveyStatus: number;
};

type TSnapshot = unknown;

function useUpdateFormStatus(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (input: TVariables) => {
    const { formId, accountId, surveyStatus } = input;
    const result = await updateFormStatus({
      accountId,
      formId,
      surveyStatus: surveyStatus === 'Enabled' ? 1 : 2,
    });
    if (result?.StatusCode === 200) {
      queryClient.invalidateQueries(['forms_list']);
    } else if (result?.Errors[0].Message) throw result;
    return result;
  });
}

export { useUpdateFormStatus };
